import { decodeApplicationDefinition } from "@next-platform/packages-ts-types";
import { axiosClient, getBaseUrlVersioned } from "../../../services/axiosClient";
import { API_VERSION } from "../../types";
export function normalizeAppSettings(appSettings) {
    if (!appSettings.applicationDefinitionEncoded) {
        return appSettings;
    }
    try {
        const applicationDefinition = decodeApplicationDefinition(appSettings.applicationDefinitionEncoded);
        return {
            ...appSettings,
            applicationDefinition,
        };
    }
    catch {
        return {
            ...appSettings,
            applicationDefinition: undefined,
        };
    }
}
/**
 * We do not keep a local cache of app settings on our side.
 * We rely on browser and server HTTP caching (Cache-Control, 10 minutes).
 */
async function fetchAppSettings({ appId }) {
    const apiUrl = `${getBaseUrlVersioned(API_VERSION.V2)}/applications/${appId}`;
    const response = await axiosClient.get(apiUrl);
    return normalizeAppSettings(response.data);
}
export default fetchAppSettings;
